var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable camelcase */
import { Component, Mixins } from 'vue-property-decorator';
import devToolMixin from '../../../util/devToolMixin';
import PropEditor from './PropEditor';
import CompInfoPanel from './CompInfoPanel';
import DatasourceDrawer from './DataDrawer';
import { pick } from "lodash-es";
import SearchableJsonView from '../../../util/SearchableJsonView';
import { startMouseMove } from "../../../../../../lib/utils";
import OptionButtons from "../../../../../../lib/comps/DevTool/util/OptionButtons";
let ConfigPanel = class ConfigPanel extends Mixins(devToolMixin) {
  constructor() {
    super(...arguments);
    this.configTabKey = 'computed';
    this.propSearchInput = '';
    this.eventSearchInput = '';
  }
  handleTabSwitch(key) {
    this.$set(this, 'configTabKey', key);
  }
  startResize(e) {
    startMouseMove({
      initialEvent: e,
      onMove: ({
        deltaX,
        deltaY
      }) => {
        const horiztonalLayout = this.displayMode === 'left' || this.displayMode === 'right';
        if (horiztonalLayout) {
          var _this$$refs;
          const dsDrawer = (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : _this$$refs.dsDrawer;
          if (this.dataSourceDrawerOpen && dsDrawer !== null && dsDrawer !== void 0 && dsDrawer.height) {
            if (this.$el.offsetHeight < 200) {
              this.dataSourceDrawerOpen = undefined;
            }
          }
        }
        this.$emit('resizePanel', !horiztonalLayout ? deltaX : deltaY);
      },
      onEnd: () => this.$emit('resizePanelEnd')
    });
  }
  get currentRenderer() {
    var _this$currentScope;
    return ((_this$currentScope = this.currentScope) === null || _this$currentScope === void 0 || (_this$currentScope = _this$currentScope.list) === null || _this$currentScope === void 0 ? void 0 : _this$currentScope[this.currentScopedSlotIndex]) || this.uc.renderer;
  }
  get computedEvent() {
    const {
      activeLayout
    } = this;
    if (!(activeLayout !== null && activeLayout !== void 0 && activeLayout.events)) return;
    return Object.entries(activeLayout.events).reduce((prev, cur) => {
      var _cur$1$steps;
      // eslint-disable-next-line no-param-reassign
      prev[cur[0]] = (_cur$1$steps = cur[1].steps) === null || _cur$1$steps === void 0 ? void 0 : _cur$1$steps.map(step => pick(step, ['params']));
      return prev;
    }, {});
  }
  render() {
    var _this$currentRenderer;
    const h = arguments[0];
    return h("div", {
      "class": "ucd-devTool-layout-propPanel"
    }, [this.displayMode === 'seperate' || this.displayMode === 'bottom' ? [h("div", {
      "class": "resizer",
      "on": {
        "mousedown": this.startResize
      }
    }), this.displayMode !== 'bottom' && h(OptionButtons)] : h("div", {
      "class": "resizer-horizontal",
      "on": {
        "mousedown": this.startResize
      }
    }), h("a-tabs", {
      "on": {
        "change": this.handleTabSwitch
      },
      "class": "ucd-devTool-layout-propPanel-tabs",
      "model": {
        value: this.configTabKey,
        callback: $$v => {
          this.configTabKey = $$v;
        }
      }
    }, [h("a-tab-pane", {
      "key": "computed",
      "attrs": {
        "tab": "数据"
      },
      "style": {
        paddingLeft: '5px'
      }
    }, [h(SearchableJsonView, {
      "attrs": {
        "value": (_this$currentRenderer = this.currentRenderer) === null || _this$currentRenderer === void 0 || (_this$currentRenderer = _this$currentRenderer.getRefByPath(this.activeCompPath)) === null || _this$currentRenderer === void 0 ? void 0 : _this$currentRenderer.$props,
        "initKey": "props",
        "rootLevelKeys": ['props'],
        "searchInput": this.propSearchInput,
        "searchPlaceholder": "过滤数据"
      },
      "on": {
        "searchInputChange": val => this.propSearchInput = val
      }
    }), this.computedEvent ? h(SearchableJsonView, {
      "attrs": {
        "value": this.computedEvent,
        "initKey": "events",
        "rootLevelKeys": ['events'],
        "searchInput": this.eventSearchInput,
        "searchPlaceholder": "过滤事件"
      },
      "on": {
        "searchInputChange": val => this.eventSearchInput = val
      }
    }) : null]), h("a-tab-pane", {
      "key": "prop",
      "attrs": {
        "tab": "属性"
      }
    }, [h(PropEditor)]), h("a-tab-pane", {
      "key": "info",
      "attrs": {
        "tab": "组件信息"
      }
    }, [h(CompInfoPanel)])]), h(DatasourceDrawer, {
      "ref": 'dsDrawer'
    })]);
  }
};
ConfigPanel = __decorate([Component({
  name: 'ConfigPanel'
})], ConfigPanel);
export default ConfigPanel;